import api from "./api";
import { Order, Payment, PaymentStatus } from "../model/types";

export const placeOrder = async (payload: {
  deliveryAddress: string;
}): Promise<Order> => {
  const response = await api.post<Order>("/orders", payload);
  return response.data;
};

export const getMyOrders = async (): Promise<Order[]> => {
  const response = await api.get<Order[]>("/orders/me");
  return response.data;
};

export const cancelOrder = async (orderId: number): Promise<Order> => {
  const response = await api.patch<Order>(`/orders/${orderId}/cancel`);
  return response.data;
};

export const payForOrder = async (payload: {
  orderId: number;
  status: PaymentStatus;
  transactionReference: string;
}): Promise<Payment> => {
  const response = await api.patch<Payment>("/payments", payload);
  return response.data;
};

export const getPaymentByOrder = async (orderId: number): Promise<Payment> => {
  const response = await api.get<Payment>(`/payments/order/${orderId}`);
  return response.data;
};
